module.exports = __webpack_public_path__ + "static/media/class.09e6f096.svg";